import '.f9{border:1px solid transparent;}.ssr-plugin'
import '.fk{outline:none;}.ssr-plugin'
import '.eg{text-align:right;}.ssr-plugin'
import '.a8{background:transparent;}.ssr-plugin'
import '.hd{height:36px;}.ssr-plugin'
import '.ga{padding-right:8px;}.ssr-plugin'
import '.k0{max-width:112px;}.ssr-plugin'
import {
  getHours,
  getMinutes,
  addMinutes,
  startOfDay,
  addHours,
} from 'date-fns'
import { styled, Style } from 'inlines'
import { useEffect, useState, useRef } from 'react'
import { radius } from '../../utils/radius.js'
import { colors } from '../../tokens/colors.js'
import { TEXT_VARIANT_STYLES } from '../../tokens/typography.js'

const normalizeTime = (str: string): string | null => {
  const lowerStr = str.toLowerCase()
  const hasAM = lowerStr.includes('am')
  const hasPM = lowerStr.includes('pm')

  const digits = str.replace(/\D/g, '')
  if (digits.length === 0) return null

  let hours: number | null = null
  let minutes: number | null = null

  if (digits.length <= 2) {
    hours = parseInt(digits.padStart(2, '0'))
    minutes = 0
  } else if (digits.length === 3) {
    hours = parseInt(digits.slice(0, 1).padStart(2, '0'))
    minutes = parseInt(digits.slice(1).padStart(2, '0'))
  } else {
    hours = parseInt(digits.slice(0, 2))
    minutes = parseInt(digits.slice(2).padEnd(2, '0'))
  }

  if (hasPM && hours !== null && hours >= 1 && hours <= 12) {
    if (hours !== 12) {
      hours += 12
    }
  } else if (hasAM && hours !== null && hours === 12) {
    hours = 0
  }

  if (
    hours != null &&
    minutes != null &&
    hours >= 0 &&
    hours <= 23 &&
    minutes >= 0 &&
    minutes <= 59
  ) {
    return `${hours.toString().padStart(2, '0')}:${minutes
      .toString()
      .padStart(2, '0')}`
  }
  return null
}

const isValidTime = (str: string) =>
  /^([0-9]|0[0-9]|1[0-9]|2[0-3]):([0-5]\d)$/.test(str)

export const TimeInput = ({
  format = 'hh:mm',
  value: rawValue,
  onChange,
  ...props
}: {
  format?: 'hh:mm' | 'mm:ss'
  value?: Date
  onChange: (e: any) => any
} & Style &
  React.InputHTMLAttributes<HTMLInputElement> & {
    ref?: React.Ref<HTMLInputElement>
  }) => {
  const [state, setState] = useState('')
  const lastValid = useRef('')
  const internalChange = useRef(false)

  useEffect(() => {
    if (!internalChange.current) {
      if (rawValue) {
        const hours = getHours(rawValue)
        const minutes = getMinutes(rawValue)
        const str = `${hours.toString().padStart(2, '0')}:${minutes
          .toString()
          .padStart(2, '0')}`
        setState(str)
        lastValid.current = str
      } else {
        setState('')
        lastValid.current = ''
      }
    } else {
      internalChange.current = false
    }
  }, [rawValue])

  const applyChange = (v: string) => {
    const hours = parseInt(v.split(':')[0])
    const minutes = parseInt(v.split(':')[1])
    let updatedDate = addMinutes(startOfDay(rawValue ?? new Date()), minutes)
    updatedDate = addHours(updatedDate, hours)
    internalChange.current = true
    onChange(updatedDate)
  }

  return (
    <div
      style={{ display: 'flex', alignItems: 'center', justifyContent: 'end' }}
    >
      <styled.input className="f9 fk eg a8 hd ga k0"
        type="text"
        placeholder="Add time"
        maxLength={12}
        value={state}
        style={{
          borderRadius: radius[12],
          color: colors.neutral80,
          ...TEXT_VARIANT_STYLES['display-regular'],
        }}
        onChange={(e) => {
          const raw = e.target.value
          setState(raw)
          const normalized = normalizeTime(raw)
          if (normalized) {
            applyChange(normalized)
            lastValid.current = normalized
          }
        }}
        onBlur={(e) => {
          const raw = e.target.value
          const normalized = normalizeTime(raw)
          if (normalized) {
            setState(normalized)
            lastValid.current = normalized
          } else {
            setState(lastValid.current)
          }
        }}
      />
    </div>
  )
}
